
//import {db, functions} from "@/scripts/firebase";
//import {TaskSheet } from "@/common-datatypes";
import { Component,Mixins,Watch } from "vue-property-decorator"
import {onSnapshot,Unsubscribe} from 'firebase/firestore'
import PlayingList from "@/components/PlayingList.vue"
//import StaffInboxOnReferenceObjects from "@/components/StaffInboxOnReferenceObjects.vue"
import { ValidationObserver } from 'vee-validate'
import Common from '@/mixins/common'
import { Playground } from "@/common-datatypes"
import { NoticeProps } from "@/scripts/datatypes"

@Component({
  components: {
    PlayingList,
    //StaffInboxOnReferenceObjects
  }
})

//TODO 連絡機能を実装する


export default class PlaygroundList extends Mixins(Common) {
  observers: (Unsubscribe | undefined)[] = []

  playgrounds: Playground[] = []

  playgroundTitle = ''

  get isDisabled(){
    return ! this.playgroundTitle
  }

  //showModalTaskMessenger = false

  defaultModalMessengerProps = {
    replyMessageId: '',
    replyAllMessageId: '',
    reviewMessageId: '',
    theMessageId: '',
    //theTaskData: undefined as (undefined | TaskSheet)
  }

  modalMessengerProps = {} as this["defaultModalMessengerProps"]

  playgroundsProps = {} as {[key: string]: {hidden: boolean}}
  isLoading = false
	notice: NoticeProps = {} 
 
  get searchObserver(){
    return this.$refs.searchPlaygroundFormValidationObserver as InstanceType<typeof ValidationObserver>;
  }

  get createObserver(){
    return this.$refs.createPlaygroundValidationObserver as InstanceType<typeof ValidationObserver>;
  }

  search = ''

  searchResult = ''

  searchResultsNum = 0

  init = false
/*
  updated(){
   const hash = this.$route.query.schedulingId || ''
   if(this.init && hash){
     const targetEl =  this.$el.querySelector('#' + hash)
      if(targetEl){
        targetEl.scrollIntoView({behavior: 'smooth'})
      }
      this.init = false
   }
  }
  
  */

  @Watch('search')
  changeSearchText(val: string){
    let searchResultsNum = 0
    searchResultsNum = 1
    this.playgrounds.forEach((pg) => {
      if(pg.docId){
        if(val.length === 0){
          this.playgroundsProps[pg.docId] = {hidden: false}
          return
        }

        if(pg.title && pg.title.indexOf(val) > -1){
          this.playgroundsProps[pg.docId] = {hidden: false}
          searchResultsNum ++
          return
        }

        this.playgroundsProps = {
          ...this.playgroundsProps,
          [pg.docId]: {hidden: true}
        }
      }
    })

    if(val && searchResultsNum === 0){
      this.searchResult = this.$t('playground.notFound') as string
    }else{
      this.searchResult = ''
    }
    this.searchResultsNum = searchResultsNum
  }

  async created(){
    console.trace('created')

    this.$store.commit("setLoading",true);
    this.isLoading = true

    // prayground を取得
    try{
      this.observers.push(onSnapshot(this.$getPlaygroundColRef(),(snapshot) => {
        //snapshot.docChanges
        snapshot.docs.forEach((doc) => {
          const row = doc.data() as Playground

          const findIndex = this.playgrounds.findIndex((playground) => {return playground.docId === doc.id})
          const deleteCount = (findIndex === -1 ? 0 : 1)
          this.playgrounds.splice(findIndex,deleteCount,row)

          if(deleteCount === 0){
            this.playgroundsProps = {
              ...this.playgroundsProps,
              [doc.id]: {hidden: false}
            }
          }

          this.playgrounds.sort((a,b) => {
            if(a.updateTime && b.updateTime){
              return b.updateTime.getTime() - a.updateTime.getTime()
            }
            return 0
          })
        })
      }))
     
    }catch(error){
      console.log(error)
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
      this.init = true
    }
  }

  public async createPlayground() {
    try{
      this.notice = {
        isShow: false,
      }

      if(! await this.createObserver.validate()){
        return
      }

      this.$store.commit("setLoading",true);
      this.isLoading = true

      const data: Playground = {
        title: this.playgroundTitle,
      }

      await this.$createDoc(this.$getPlaygroundColRef(),data)

/*
      this.notice = {
        message: this.$t('addSchool.added') as string,
        duration: 0,
        isShow: true,
        type: {'is-info': true}
      }
*/
      this.playgroundTitle = ''
      this.createObserver.reset()

    }catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)
      const errorMessage0 = this.$t('addSchool.error') as string

      const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

      const errorField = this.$getErrorField(errorCode)

      if(errorMessage1 && errorField){
        this.createObserver.setErrors({
         [errorField]: errorMessage1
        })
      }

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

/*
  sendTask(pg: TaskSheet){
    console.log(pg)
    this.modalMessengerProps = {
      ...this.defaultModalMessengerProps,
      theTaskData: pg
    }
    this.showModalTaskMessenger = true
  }
*/

/*
  editMessage(messageId: string,pg: TaskSheet){
    this.modalMessengerProps = {
      ...this.defaultModalMessengerProps,
      theMessageId: messageId,
      theTaskData: pg
    }
    this.showModalTaskMessenger = true
  }
*/

/*
  replyMessage(messageId: string,pg: TaskSheet){
    this.modalMessengerProps = {
      ...this.defaultModalMessengerProps,
      replyMessageId: messageId,
      theTaskData: pg
    }
    this.showModalTaskMessenger = true
  }
*/

/*
  replyAllMessage(messageId: string,pg: TaskSheet){
    this.modalMessengerProps = {
      ...this.defaultModalMessengerProps,
      replyAllMessageId: messageId,
      theTaskData: pg
    }
    this.showModalTaskMessenger = true
  }
*/

/*
  reviewMessage(messageId: string,pg: TaskSheet){
    this.modalMessengerProps = {
      ...this.defaultModalMessengerProps,
      reviewMessageId: messageId,
      theTaskData: pg
    }
    this.showModalTaskMessenger = true
  }
 */
  destroyed() {
    console.trace('destroyed')
    this.$unsubscriber(this.observers)
  }

}
